/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getSurvey = /* GraphQL */ `query GetSurvey($id: ID!) {
  getSurvey(id: $id) {
    termAgreement {
      personalInfo
      service
      __typename
    }
    mainSurveyCode
    mainSymptom
    mode
    surveyType
    patient {
      patientName
      gender
      birth
      __typename
    }
    clinic
    completedDt
    id
    firstLinkClickDt
    visitCount
    rawData
    reviewRating
    reviewComment
    byeonjeungData
    recommendHerbs
    solutionClickCount
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetSurveyQueryVariables, APITypes.GetSurveyQuery>;
export const listSurveys = /* GraphQL */ `query ListSurveys(
  $filter: ModelSurveyFilterInput
  $limit: Int
  $nextToken: String
) {
  listSurveys(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      mainSurveyCode
      mainSymptom
      mode
      surveyType
      clinic
      completedDt
      id
      firstLinkClickDt
      visitCount
      rawData
      reviewRating
      reviewComment
      byeonjeungData
      recommendHerbs
      solutionClickCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSurveysQueryVariables,
  APITypes.ListSurveysQuery
>;
export const syncSurveys = /* GraphQL */ `query SyncSurveys(
  $filter: ModelSurveyFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncSurveys(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      mainSurveyCode
      mainSymptom
      mode
      surveyType
      clinic
      completedDt
      id
      firstLinkClickDt
      visitCount
      rawData
      reviewRating
      reviewComment
      byeonjeungData
      recommendHerbs
      solutionClickCount
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncSurveysQueryVariables,
  APITypes.SyncSurveysQuery
>;
